<script setup lang="ts">
import selectRoleChecker from "@/router/selectRoleChecker";
import auditLogType from "@/types/responses/auditLog";
import i18n from "@/lang/i18n";
import {
  MANAGEMENT_OFFICE_TYPE,
  SUB_MANAGEMENT_OFFICE_TYPE,
} from "@/services/consts";

const props = defineProps<{
  auditLog: auditLogType
}>()

function openInNewWindow() {
  const selectedRole = selectRoleChecker.getCurrentRole()
  if (!selectedRole) {
    return
  }

  switch (props.auditLog.auditable_type) {
    case 'account':
      window.open(`/accounts/form/${props.auditLog.auditable_id}`, '_blank')
      break
    case 'operation_office':
      if (selectedRole.organization_type === MANAGEMENT_OFFICE_TYPE || selectedRole.organization_type === SUB_MANAGEMENT_OFFICE_TYPE) {
        window.open(`/operation-offices/form/${props.auditLog.auditable_id}`, '_blank')
      }
      window.open(`/operation-office-edit`, '_blank')
      break
    case 'delivery_plan_work':
      window.open(`/daily-report?delivery_plan_id=${props.auditLog.auditable_id}`, '_blank')
      break
    case 'workload':
      window.open(`/daily-report?delivery_plan_id=${props.auditLog.auditable.delivery_plan_id}`, '_blank')
      break
    case 'vehicle':
      window.open(`/vehicles/form/${props.auditLog.auditable_id}`, '_blank')
      break
    case 'spot':
      window.open(`/spots?id=${props.auditLog.auditable_id}`, '_blank')
      break
    case 'report_layout':
      window.open(`/daily-report-layouts?id=${props.auditLog.auditable_id}`, '_blank')
      break
    default:
      break
  }
}

function tooltipText() {
  switch (props.auditLog.auditable_type) {
    case 'account':
      return i18n.global.t('pages.auditLog.openNewWindow.account')
    case 'operation_office':
      return i18n.global.t('pages.auditLog.openNewWindow.operationOffice')
    case 'delivery_plan_work':
    case 'workload':
      return i18n.global.t('pages.auditLog.openNewWindow.dailyReports')
    case 'vehicle':
      return i18n.global.t('pages.auditLog.openNewWindow.vehicle')
    case 'spot':
      return i18n.global.t('pages.auditLog.openNewWindow.spots')
    case 'report_layout':
      return i18n.global.t('pages.auditLog.openNewWindow.reportLayouts')
    default:
      return ''
  }
}
</script>
<template>
  <v-tooltip
    location="bottom"
    :open-delay="500"
  >
    <template #activator="{ props: activatorProps }">
      <span v-bind="activatorProps">
        <v-btn
          density="default"
          variant="text"
          @click="openInNewWindow()"
        >
          <span class="material-symbols-outlined">
            open_in_new
          </span>
        </v-btn>
      </span>
    </template>
    {{ tooltipText() }}
  </v-tooltip>
</template>
